/** Animated map ripple drawn over a screenshot, matching the app's venue beams (CheckedInVenueMapCircles). */
export interface ScreenshotPulse {
  kind: 'checkIn' | 'hotspot'
  /** Center as a percentage of the screenshot's width / height. */
  x: number
  y: number
}

export interface ChatStoryMessage {
  from: 'me' | 'them'
  text: string
  time: string
}

/** A conversation the phone plays as live messaging (typing, then sending) instead of a static screenshot. */
export interface ChatStoryScript {
  contactName: string
  contactPhoto: string
  messages: ChatStoryMessage[]
}

export interface HowItWorksStep {
  number: string
  kicker: string
  title: string
  description: string
  // Web-sized copies of public/images/screenshots/*_screen.png
  screenshotSrc?: string
  screenshotLabel: string
  pulses?: ScreenshotPulse[]
  /** Shown instead of [screenshotSrc] when set. */
  chat?: ChatStoryScript
}

export const HOW_IT_WORKS_STEPS: HowItWorksStep[] = [
  {
    number: '01',
    kicker: 'Step one',
    title: 'See who’s out.',
    description:
      'Explore bars, cafés, gyms, parks, and other spots near you. See how many people are checked in, who was recently there, and who’s planning to go.',
    screenshotSrc: '/images/landing-v2/map-screen.jpg',
    screenshotLabel: 'Ivy map screen: venues around Chicago with how many people are checked in at each.',
    pulses: [
      { kind: 'hotspot', x: 30.5, y: 50 },
      { kind: 'checkIn', x: 63.6, y: 73.3 },
    ],
  },
  {
    number: '02',
    kicker: 'Step two',
    title: 'Check in when you get there.',
    description: 'Arrive at a spot and check in. Profiles open up so you can see who’s there and interested in meeting.',
    screenshotSrc: '/images/landing-v2/checked-in-screen.jpg',
    screenshotLabel: 'Ivy venue screen after checking in: Jessica, Liam, Maya, Nora and Sofia are there right now.',
  },
  {
    number: '03',
    kicker: 'Step three',
    title: 'Go say hello.',
    description: 'Send a message to find each other. “I’m by the window” is plenty. Take the conversation from there, in person.',
    screenshotLabel: 'Ivy chat with Jessica, checked in at the same bar: planning trivia night together and finding each other.',
    chat: {
      contactName: 'Jessica, 27, F',
      contactPhoto: '/images/landing-v2/profiles/jessica.jpg',
      messages: [
        { from: 'me', text: 'Hey Jessica! Saw you just checked in 👋', time: '8:01 PM' },
        { from: 'them', text: 'Hey! Here for trivia night 🧠🍻', time: '8:02 PM' },
        { from: 'me', text: 'Same! It starts at 8:30. Want to team up?', time: '8:02 PM' },
        { from: 'them', text: 'Only if you’re good at the music round 🎶😄', time: '8:03 PM' },
        { from: 'me', text: 'Deal 🤝 I’m at the end of the bar, blue jacket', time: '8:04 PM' },
        { from: 'them', text: 'Coming over! 💚', time: '8:04 PM' },
      ],
    },
  },
]
